module.exports = __webpack_public_path__ + "fonts/ionicons.24712f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.ttf?v=2.0.0
// module id = 1028
// module chunks = 14